/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import { toastSuccess } from '../utils/toasts';
import OrdersTableSkeleton from '../components/OrdersTableSkeleton';
import CustomModal from '../components/atoms/CustomModal';
import useGetParams from '../hooks/useGetParams';
import { useGetAllReferralsQuery } from '../store';
import ReferralsTable from '../components/ReferralsTable';
import CreateEditReferral from '../components/CreateEditReferral';
import AdminSectionTitle from '../components/AdminSectionTitle';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import Link from '../components/icons/Link';

const AdminReferralsPage: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { eventId, businessId } = useGetParams();
  const { event } = useGetSelectedEvent();
  const { data: referrals, isFetching } = useGetAllReferralsQuery({
    businessId,
    eventId,
  });

  const handleSucessAddReferral = () => {
    setShowModal(false);
    toastSuccess('Referido creado correctamente');
  };

  const handleAddReferral = () => {
    setShowModal(true);
  };

  const filteredReferrals = referrals?.filter((fr) => fr.owner_referral_order_id === null);

  return (
    <div className="flex flex-col gap-8 my-6">
      <AdminSectionTitle title="Eventos" subtitle={`${event?.name} - Referidos`} />
      <div className="glass-surface">
        <h1 className="text-2xl mb-2">Referidos</h1>
        {isFetching && <OrdersTableSkeleton />}{' '}
        {referrals && (
          <ReferralsTable referrals={filteredReferrals || []} eventId={eventId} businessId={businessId} button={{
            label: 'Crear referido',
            onClick: handleAddReferral,
            variant: 'secondary',
            reactIcon: <Link className='text-xl'/>,
          }} />
        )}
      </div>
      <CustomModal
        onRequestClose={() => setShowModal(false)}
        isOpen={showModal}
        actionBar={<div></div>}
        hideCancelButton={true}
      >
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h1 className="text-xl font-medium">Crear referido</h1>
            <p className="text-text-tertiary text-sm">
              Podrás realizar las ediciones que necesites en este referido
            </p>

          </div>
          <CreateEditReferral onSuccess={handleSucessAddReferral} onCancel={() => setShowModal(false)} />
        </div>
      </CustomModal>
    </div>

  );
};

export default AdminReferralsPage;
